import _typeof from "@babel/runtime/helpers/esm/typeof";
import isElectron from './is-electron';
export default function isBrowser() {
  var isNode = (typeof process === "undefined" ? "undefined" : _typeof(process)) === 'object' && String(process) === '[object process]' && !process.browser;
  return !isNode || isElectron();
}
export function isBrowserMainThread() {
  return isBrowser() && typeof document !== 'undefined';
}
//# sourceMappingURL=is-browser.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/probe.gl/dist/esm/env/is-browser.js
// module id = 262
// module chunks = 0